// extracted by mini-css-extract-plugin
export default {"item":"List_item__pxQNP"};